// Note: Not called scrolling-events-dispatcher, because the namespacing felt dumb at that point.

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Scrolling = Lfl.Scrolling || {};

    (function (Scrolling, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Scrolling, 'EventsDispatcher')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Handles and dispatches scrolling events.
         *
         * @memberOf Lfl.Scrolling
         */
        Lfl.Scrolling.EventsDispatcher = Scrolling.EventsDispatcher || {};

        (function (EventsDispatcher, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition
             |==========================================================================================================
             */

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            /**
             *
             * @type {Lfl.Animations.EventThrottler[]}
             */
            var emulatedScrollingListeners = [];

            /*
            |----------------------------------------------------------------------------------------
            | Registering
            |------------- */

            /**
             * Registers a throttled event listener for emulated scrolling events.
             *
             * @param {function | Lfl.Animations.EventThrottler} listener An event throttler or a function which will be
             * wrapped inside a default throttler. (That is done to reduce the impact of the event handling on the
             * application's performance.)
             * @memberOf Lfl.Scrolling.EventsDispatcher
             */
            EventsDispatcher.onEmulatedScroll = function (listener) {
                emulatedScrollingListeners.push(Lfl.Animations.EventThrottler.wrapInThrottlerIfNot(listener));
            };

            /**
             * Registers a throttled event listener for native scrolling events.
             *
             * @param {function | Lfl.Animations.EventThrottler} listener An event throttler or a function which will be
             * wrapped inside a default throttler. (That is done to reduce the impact of the event handling on the
             * application's performance.)
             * @memberOf Lfl.Scrolling.EventsDispatcher
             */
            EventsDispatcher.onNativeScroll = function (listener) {
                $(window).scroll(Lfl.Animations.EventThrottler.wrapInThrottlerIfNot(listener).performTheThrottledCallback);
            };

            /**
             * Registers a throttled event listener for scrolling events (either called by a browser's native scroll bar
             * or by a emulated one, handled by a scrolling plugin).
             *
             * @param {function | Lfl.Animations.EventThrottler} listener An event throttler or a function which will be
             * wrapped inside a default throttler. (That is done to reduce the impact of the event handling on the
             * application's performance.)
             * @memberOf Lfl.Scrolling.EventsDispatcher
             */
            EventsDispatcher.onAnyScroll = function (listener) {
                // Having one throttler for both should not ever make any difference, as in theory either native, or
                // emulated scroll is active on a given element, but not both at the same time. It does not hurt to
                // have it this way, though.
                var throttler = Lfl.Animations.EventThrottler.wrapInThrottlerIfNot(listener);
                this.onEmulatedScroll(throttler);
                this.onNativeScroll(throttler);
            };

            /*
            |----------------------------------------------------------------------------------------
            | Firing
            |-------- */

            /**
             * Fires the event that scrolling event occurred inside a plugin used for scrolling.
             *
             * Note: Arguments passed to this function will be passed on to the listener.
             *
             * @memberOf Lfl.Scrolling.EventsDispatcher
             */
            EventsDispatcher.fireEmulatedScroll = function () {
                var outerArguments = arguments;
                _.each(emulatedScrollingListeners, function (/** Lfl.Animations.EventThrottler */throttler, key) {
                    throttler.performTheThrottledCallback.apply(null, outerArguments);
                });
            };

            /*
             |----------------------------------------------------------------------------------------------------------
             | Private methods
             |----------------------------------------------------------------------------------------------------------
             */
        }(Scrolling.EventsDispatcher, jQuery));
    }(Lfl.Scrolling, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
